import React, { useMemo, useState, useCallback } from 'react'
import './order-detail.scss'
import { BaseDrawer } from '@/components/drawer/base-drawer'
import { layerManage, showLayer } from '@/utils/layer'
import useBemClass from '@/utils/hooks/useBEMClass'
import { Row, Column, Expaned } from '@/components/layout/layout'
import { useRequest } from 'ahooks'
import { $post } from '@/api'
import { IMallOrderDetail } from './type'
import { Table, Spin } from 'antd'
import $msg from '@/utils/message'
import FormTitle from '@/views/main/modules/goods-manage/components/form/form-title/form-title'
import RecordLine, { RecordLineItem } from './record-line/record-line'
import { getOrderStatus } from './order-status'
import { ColumnsType } from 'antd/lib/table'
import Big from 'big.js'
import RemarkPopover from '@/views/main/modules/goods-manage/components/remark-popover/remark-popover'
import Button from '@/components/button/button'
import Iconfont from '@/components/iconfont/iconfont'
import copy from 'copy-to-clipboard'
import mallOrderStatus from '../../order-dialog/order-status-action'
import { errorCallBack, deepClone, setObj, get } from '@/utils'
import PopverConfirm2 from '@/components/popover-confirm/popver-confirm-2'
import newUserImg from '@/assets/images/new-user.svg'
import MallOrderRefund from '../../order-refund/order-refund'
import LayoutInput from '@/views/main/modules/goods-manage/components/form/layout-input/layout-input'
import classnames from 'classnames'
import youhuiquanIcon from '@/assets/images/youhuiquan-icon.svg'
import minusIcon from '@/assets/images/minusIcon.svg'
import timeDiscountIcon from '@/assets/images/time-discount.svg'
import ScoreIcon from '@/assets/images/score20.svg'
import { mallOrderStore } from '../../store'
import MallOrderReplenish from './order-replenish/order-replenish'
import { mallOrderTypeTag } from '../order-table/order-table'

interface OrderDetailProps {
    orderId?: number
    orderType?: number
    orderNo?: string
}
const payTypesMap: Record<string, string> = {
    '7': '微信支付',
    '17': '微信支付',
    '13': '微信支付',
    '23': '微信支付',
    '18': '货到付款',
    '4': '余额支付',
    '100': '无',
}

const MallOrderDetail: React.FC<OrderDetailProps> = props => {
    const cls = useBemClass('mall-order-detail')

    const [goodList, setGoodList] = useState<IMallOrderDetail.OrderGoodsList[]>([])

    const orderDetailReq = useRequest<IMallOrderDetail.Data>(
        () =>
            $post({
                url: '/mall/getonlineordershop',
                params: {
                    order_id: props.orderId,
                    order_type: props.orderType,
                    order_no: props.orderNo,
                },
            }),
        {
            onSuccess: d => setGoodList(d.order_goods_list),
            onError: e => $msg('error', e.message),
        },
    )

    const orderStatusAction = useMemo(() => {
        if (orderDetailReq.data) {
            if (orderDetailReq.data.order.status === 4) {
                return (type: 'accpet' | 'refuse') =>
                    mallOrderStatus(
                        orderDetailReq.data!.order,
                        () => {
                            orderDetailReq.run()
                            mallOrderStore.setOrderListRefresh()
                        },
                        type,
                    )
            }

            return mallOrderStatus(orderDetailReq.data.order, () => {
                orderDetailReq.run()
                mallOrderStore.setOrderListRefresh()
            })
        } else {
            return null
        }
    }, [orderDetailReq])

    const computeDiscountTotal = useCallback(
        (key: 'member_discount_rate' | 'timed_discount_rate', initVal: number) =>
            goodList.reduce((prev, next) => {
                const gapPrice = +Big(1).minus(next[key]).times(next.price).round(2)
                const context = !next.delivered_amount
                    ? 0
                    : +new Big(+next.delivered_amount).minus(next.amount).times(gapPrice).round(2)

                return +new Big(context).add(+prev).round(2)
            }, initVal),
        [goodList],
    )

    const memberDiscount = useMemo(() => {
        if (Object.keys(orderDetailReq.data?.supplement_refund_info || {}).length) {
            return orderDetailReq.data?.order.member_discount_amount
        }

        return computeDiscountTotal('member_discount_rate', orderDetailReq.data?.order.member_discount_amount || 0)
    }, [computeDiscountTotal, orderDetailReq.data])

    const timeDiscount = useMemo(() => {
        if (Object.keys(orderDetailReq.data?.supplement_refund_info || {}).length) {
            return orderDetailReq.data?.order.timed_discount_amount
        }

        return computeDiscountTotal('timed_discount_rate', orderDetailReq.data?.order.timed_discount_amount || 0)
    }, [computeDiscountTotal, orderDetailReq.data])

    const columns: ColumnsType<IMallOrderDetail.OrderGoodsList> = [
        {
            title: '#',
            key: 'index',
            width: 50,
            render: (value, record, index) => index + 1,
        },
        {
            title: '商品名',
            key: 'goods',
            ellipsis: true,
            render: (val, r) => (
                <Column>
                    <div>{r.goods_name}</div>
                    {r.price_annotation && (
                        <div data-margin-top-2 data-color-999 data-font-size-12>
                            {r.price_annotation}
                        </div>
                    )}
                </Column>
            ),
        },
        {
            title: '实配量',
            width: 123,
            key: 'amount',
            render: (val, r, index) =>
                !Object.keys(orderDetailReq.data?.supplement_refund_info || {}).length &&
                orderDetailReq.data?.order.status === 2 &&
                orderDetailReq.data?.order.refund_status === 0 ? (
                    <Row data-align-items-center>
                        <LayoutInput
                            value={r.amount + ''}
                            placeholder="请录入"
                            onBlur={e => {
                                const amount = parseFloat(e) || 0
                                setGoodList(deepClone(setObj(setObj(goodList, `[${index}].delivered_amount`, amount))))
                            }}
                        />
                        {r.goods_unit.name}
                    </Row>
                ) : r.delivered_amount && r.delivered_amount !== r.amount ? (
                    <Column data-align-items-flex-end>
                        <div>
                            {r.delivered_amount} {r.goods_unit.name}
                        </div>
                        <div className={cls('del')}>
                            {r.amount} {r.goods_unit.name}
                        </div>
                    </Column>
                ) : (
                    <Column data-align-items-flex-end>{r.amount + r.goods_unit.name}</Column>
                ),
        },
        {
            title: '小计',
            key: 'price',
            dataIndex: 'price',
            align: 'right',
            render: (v, r) => {
                const tmp = +Big(r.delivered_amount || 0)
                    .times(r.price)
                    .round(2)

                return r.delivered_amount ? (
                    <Column data-align-items-flex-end>
                        ¥{+Big(r.delivered_amount).times(r.price).round(2)}
                        {tmp !== v && <div className={cls('del')}>¥{v}</div>}
                    </Column>
                ) : (
                    `¥${v}`
                )
            },
        },
    ]

    const operationRecord: RecordLineItem[] = useMemo(() => {
        if (orderDetailReq.data?.order_operate_records && orderDetailReq.data?.order_operate_records.length) {
            return orderDetailReq.data.order_operate_records.map(r => ({
                time: r.create_time,
                content: getOrderStatus({ ...r, order: orderDetailReq.data?.order }),
                key: r.operation,
            }))
        }

        return []
    }, [orderDetailReq.data])

    const priceGap = useMemo(() => {
        if (Object.keys(orderDetailReq.data?.supplement_refund_info || {}).length) {
            if (orderDetailReq.data?.supplement_refund_info.type === 0) {
                return 0 - orderDetailReq.data!.supplement_refund_info.subtotal
            } else {
                return orderDetailReq.data!.supplement_refund_info.subtotal
            }
        } else {
            if (!goodList.length) return 0

            return goodList.reduce((prev, next) => {
                if (!next.delivered_amount) {
                    return prev
                } else {
                    return +Big(next.delivered_amount)
                        .minus(next.amount)
                        .times(next.price)
                        .times(next.member_discount_rate)
                        .times(next.timed_discount_rate)
                        .round(2)
                        .add(+prev)
                }
            }, 0)
        }
    }, [goodList, orderDetailReq.data])

    const isSubtotalChange = useMemo(
        () => priceGap || !!Object.keys(orderDetailReq.data?.supplement_refund_info || {}).length,
        [orderDetailReq.data, priceGap],
    )

    const updateRemarkReq = useRequest(
        (remarks: string) =>
            $post({
                url: '/mall/updateorderremarks',
                params: {
                    remarks,
                    order_id: props.orderId,
                    order_type: props.orderType,
                },
            }),
        {
            manual: true,
            onSuccess: () => {
                $msg('success', '更新成功')
                orderDetailReq.refresh()
            },
        },
    )

    const printOrderReq = useRequest(
        () =>
            $post({
                url: '/mall/orderprint',
                params: {
                    order_id: orderDetailReq.data?.order.order_id,
                    order_type: orderDetailReq.data?.order.order_type,
                },
            }),
        {
            manual: true,
            onSuccess: () => {
                $msg('success', '打印完成')
            },
            onError: errorCallBack,
        },
    )

    const finishOrderReq = useRequest(
        () =>
            $post({
                url: '/mall/orderconfirmdelivery',
                params: {
                    order_id: orderDetailReq.data?.order.order_id,
                    order_type: orderDetailReq.data?.order.order_type,
                },
            }),
        {
            manual: true,
            onSuccess: () => {
                $msg('success', '订单已一键完成')
                mallOrderStore.setOrderListRefresh()
                orderDetailReq.run()
            },
            onError: errorCallBack,
        },
    )

    const activityTag = useMemo(() => {
        return get(mallOrderTypeTag, orderDetailReq.data?.order.order_type, '')
    }, [orderDetailReq.data])

    return (
        <BaseDrawer isShow width={570} onClose={() => layerManage.pop()} title="微商城订单详情">
            <Column data-height-100p>
                <Expaned data-overflow-auto>
                    <Spin spinning={orderDetailReq.loading}>
                        <div className={cls('record-container')}>
                            <RecordLine record={operationRecord} />
                        </div>
                        <FormTitle
                            title={`商品信息（${orderDetailReq.data?.order_goods_list.length || 0}）`}
                            hasLine={false}
                        />
                        <div className={cls('table-container')}>
                            <Table
                                columns={columns}
                                rowKey={r => r.order_id}
                                dataSource={goodList}
                                pagination={false}
                                bordered
                                scroll={{ x: 'max-content', y: 344 }}
                            ></Table>

                            {!!orderDetailReq.data?.order.delivery_fee && (
                                <Row className={cls('table-bottom-item')}>
                                    <div data-color-999 data-font-size-14>
                                        配送费
                                    </div>
                                    <div data-color-000 data-font-size-14>
                                        ¥{orderDetailReq.data?.order.delivery_fee}
                                    </div>
                                </Row>
                            )}

                            {!!orderDetailReq.data?.order.member_discount_amount && (
                                <Row className={cls('table-bottom-item')}>
                                    <div data-color-999 data-font-size-14>
                                        会员折扣
                                    </div>
                                    <div data-color-000 data-font-size-14>
                                        -¥{memberDiscount}
                                    </div>
                                </Row>
                            )}

                            {!!orderDetailReq.data?.order.coupon_amount && (
                                <Row className={classnames(cls('table-bottom-item'), cls('table-bottom-line'))}>
                                    <Row data-align-items-center>
                                        <img src={youhuiquanIcon} data-margin-right-8 alt="" />
                                        <div data-color-999 data-font-size-14>
                                            优惠券
                                        </div>
                                    </Row>
                                    <div data-color-000 data-font-size-14>
                                        -¥{orderDetailReq.data?.order.coupon_amount}
                                    </div>
                                </Row>
                            )}

                            {!!orderDetailReq.data?.order.points_discount_amount && (
                                <Row className={classnames(cls('table-bottom-item'), cls('table-bottom-line'))}>
                                    <Row data-align-items-center>
                                        <img src={ScoreIcon} data-margin-right-8 alt="" />
                                        <div data-color-999 data-font-size-14>
                                            积分抵扣
                                        </div>
                                    </Row>
                                    <div data-color-000 data-font-size-14>
                                        -¥{orderDetailReq.data?.order.points_discount_amount}
                                    </div>
                                </Row>
                            )}

                            {!!orderDetailReq.data?.order.timed_discount_amount && (
                                <Row className={classnames(cls('table-bottom-item'), cls('table-bottom-line'))}>
                                    <Row data-align-items-center>
                                        <img src={timeDiscountIcon} data-margin-right-8 alt="" />
                                        <div data-color-999 data-font-size-14>
                                            限时折扣
                                        </div>
                                    </Row>
                                    <div data-color-000 data-font-size-14>
                                        -¥{timeDiscount}
                                    </div>
                                </Row>
                            )}

                            {!!orderDetailReq.data?.order.minus_amount && (
                                <Row className={classnames(cls('table-bottom-item'), cls('table-bottom-line'))}>
                                    <Row data-align-items-center>
                                        <img src={minusIcon} data-margin-right-8 alt="" />
                                        <div data-color-999 data-font-size-14>
                                            满{orderDetailReq.data?.order.minus_rule_amount}减
                                            {orderDetailReq.data?.order.minus_amount}
                                        </div>
                                    </Row>
                                    <div data-color-000 data-font-size-14>
                                        -¥{orderDetailReq.data?.order.minus_amount}
                                    </div>
                                </Row>
                            )}

                            <div className={cls('table-bottom')}>
                                <span data-color-000 data-font-size-14 data-font-weight-600>
                                    {!isSubtotalChange ? '' : '实际'}合计：
                                </span>
                                <span
                                    style={{
                                        color: '#FF582A',
                                    }}
                                    data-font-weight-600
                                    data-font-size-18
                                >
                                    ¥{+Big(orderDetailReq.data?.order.actual_payment || 0).plus(priceGap)}
                                </span>
                                {isSubtotalChange && (
                                    <>
                                        <span className={cls('del-price')}>
                                            {orderDetailReq.data?.order.actual_payment}
                                        </span>
                                        <span className={cls('gap-price')}>
                                            (差价:
                                            <span
                                                style={{
                                                    color: priceGap > 0 ? '#14CC9B' : 'rgb(255, 88, 42)',
                                                }}
                                            >
                                                {`${priceGap > 0 ? '+' : '-'}`}
                                                <span data-font-size-14 data-font-weight-600>
                                                    ¥{+Big(priceGap).abs()}
                                                </span>
                                            </span>
                                            )
                                        </span>
                                    </>
                                )}
                            </div>
                        </div>
                        {!!Object.keys(orderDetailReq.data?.activity || {}).length && (
                            <>
                                <FormTitle title="活动详情" hasLine={false} />
                                <div
                                    data-row
                                    data-align-items-center
                                    data-padding-10
                                    data-font-size-14
                                    className={cls('container')}
                                >
                                    <img src={activityTag} alt="" data-margin-right-8 />
                                    {orderDetailReq.data?.activity.title}
                                </div>
                            </>
                        )}
                        <FormTitle title="订单信息" hasLine={false} />
                        <div className={cls('container')}>
                            <Row data-padding-16 data-justify-content-space-between data-align-items-flex-start>
                                <Column data-justify-content-center data-expaned>
                                    <div className={cls('list-item')}>
                                        <div className="title coll">订单编号</div>
                                        <span className="title">：</span>
                                        <div className="txt">{orderDetailReq.data?.order.order_no}</div>
                                    </div>

                                    <div data-margin-top-12 className={cls('list-item')}>
                                        <div className="title coll">支付方式</div>
                                        <span className="title">：</span>
                                        <div className="txt">
                                            {orderDetailReq.data?.payments.map(
                                                p => payTypesMap[`${p.payment_type}`] + ` ¥${p.payment_amount}`,
                                            )}
                                        </div>
                                    </div>

                                    <div data-margin-top-12 className={cls('list-item')}>
                                        <div className="title coll">订单类型</div>
                                        <span className="title">：</span>
                                        <div className="txt">
                                            {orderDetailReq.data?.order.delivery_type === 0 ? '自提' : '配送'}
                                        </div>
                                    </div>

                                    <div data-margin-top-12 className={cls('list-item')}>
                                        <div className="title coll">联系方式</div>
                                        <span className="title">：</span>
                                        <div
                                            className="action"
                                            onClick={() => {
                                                copy(orderDetailReq.data?.order.customer.phone || '')
                                                $msg('success', '复制成功')
                                            }}
                                        >
                                            {orderDetailReq.data?.order.customer.phone}
                                        </div>
                                    </div>
                                </Column>
                                <Column data-justify-content-center data-expaned>
                                    <div className={cls('list-item')}>
                                        <div className="title coll">下单时间</div>
                                        <span className="title">：</span>
                                        <div className="txt">{orderDetailReq.data?.order?.create_time}</div>
                                    </div>

                                    <div data-margin-top-12 className={cls('list-item')}>
                                        <div className="title coll">用户</div>
                                        <span className="title">：</span>
                                        <Row className="txt" data-align-items-center>
                                            <img
                                                data-margin-right-6
                                                src={orderDetailReq.data?.order?.customer.avatar}
                                                alt=""
                                                className="avatar"
                                            />
                                            <div
                                                style={{
                                                    maxWidth: '80px',
                                                }}
                                                className="text-popper"
                                            >
                                                {orderDetailReq.data?.order?.customer.realname ||
                                                    orderDetailReq.data?.order?.customer.nickname}
                                            </div>
                                            {orderDetailReq.data?.order?.first_order ? (
                                                <img data-margin-left-14 src={newUserImg} alt="" />
                                            ) : (
                                                <div className={cls('order-count-tag')}>
                                                    {orderDetailReq.data?.order?.user_order_count}单
                                                </div>
                                            )}
                                        </Row>
                                    </div>

                                    {orderDetailReq.data?.order.self_pickup_site?.address && (
                                        <div data-margin-top-12 className={cls('list-item')}>
                                            <div className="title coll">自提点</div>
                                            <span className="title">：</span>
                                            <Row className="txt" data-align-items-center>
                                                <div
                                                    style={{
                                                        maxWidth: '80px',
                                                    }}
                                                    className="text-popper"
                                                >
                                                    {orderDetailReq.data?.order.self_pickup_site?.name}
                                                </div>
                                            </Row>
                                        </div>
                                    )}
                                </Column>
                            </Row>
                            {orderDetailReq.data?.order.delivery_type !== 0 && (
                                <div
                                    data-row
                                    data-padding-16
                                    className={cls('list')}
                                    style={{
                                        borderTop: '1px solid #ddd',
                                    }}
                                >
                                    <div className="title coll">收货地址</div>
                                    <span className="title">：</span>
                                    <Row data-expaned data-overflow-hidden data-align-items-center>
                                        <Expaned data-color-000 data-font-size-14 data-column>
                                            <div>
                                                {(orderDetailReq.data?.order.address_text || '') +
                                                    (orderDetailReq.data?.order.address || '')}
                                            </div>
                                            <Row>
                                                {orderDetailReq.data?.order.receiver_name}{' '}
                                                {orderDetailReq.data?.order.phone}
                                            </Row>
                                        </Expaned>
                                        <div
                                            data-cursor-pointer
                                            onClick={() => {
                                                copy(
                                                    (orderDetailReq.data?.order.address_text || '') +
                                                        (orderDetailReq.data?.order.address || '') +
                                                        orderDetailReq.data?.order.receiver_name +
                                                        orderDetailReq.data?.order.phone,
                                                )
                                                $msg('success', '已复制到剪切板')
                                            }}
                                        >
                                            <Iconfont name="icon6fuzhi-20" size={20} />
                                        </div>
                                    </Row>
                                </div>
                            )}
                            {orderDetailReq.data?.order.remarks && (
                                <div
                                    data-row
                                    data-padding-16
                                    className={cls('list')}
                                    style={{
                                        borderTop: '1px solid #ddd',
                                    }}
                                >
                                    <div className="title coll">备注</div>
                                    <span className="title">：</span>
                                    <div data-color-ff4343 data-font-size-14 data-expaned>
                                        {orderDetailReq.data?.order.remarks}
                                    </div>
                                </div>
                            )}
                            {orderDetailReq.data?.order.shop_remarks && (
                                <div
                                    data-row
                                    data-padding-16
                                    className={cls('list')}
                                    style={{
                                        borderTop: '1px solid #ddd',
                                    }}
                                >
                                    <div className="title coll">商家备注</div>
                                    <span className="title">：</span>
                                    <div data-color-ff4343 data-font-size-14 data-expaned>
                                        {orderDetailReq.data?.order.shop_remarks}
                                    </div>
                                </div>
                            )}
                        </div>
                    </Spin>
                </Expaned>
                <div className={cls('footer')}>
                    <Row>
                        <RemarkPopover
                            value={orderDetailReq.data?.order.shop_remarks}
                            maxLen={50}
                            onConfirm={e => {
                                updateRemarkReq.run(e)
                            }}
                        >
                            <Column data-align-items-center className={cls('footer', 'left')}>
                                <i className="iconfont icon6cunweicaogao-20" data-font-size-20 />
                                <span data-font-size-16 data-margin-left-4>
                                    商家备注
                                </span>
                            </Column>
                        </RemarkPopover>

                        <Column
                            data-margin-left-20
                            data-align-items-center
                            className={cls('footer', 'left')}
                            onClick={printOrderReq.run}
                        >
                            <i
                                className="iconfont icondayin2"
                                data-font-size-20
                                style={{
                                    transform: 'scale(.9)',
                                }}
                            />
                            <span data-font-size-16 data-margin-left-4>
                                打印小票
                            </span>
                        </Column>
                    </Row>

                    <Row data-align-items-center>
                        {orderDetailReq.data?.order.status !== 4 &&
                            orderDetailReq.data?.order.refund_status === 0 &&
                            !orderDetailReq.data?.order.is_shipping && (
                                <PopverConfirm2
                                    trigger="click"
                                    types="error"
                                    onConfirm={finishOrderReq.run}
                                    content={
                                        <div>
                                            <div data-color-000 data-font-size-14>
                                                确定一键完成本单吗？
                                            </div>
                                            <div data-color-999 data-font-size-12>
                                                确认后，订单状态将会变为已完成
                                            </div>
                                        </div>
                                    }
                                >
                                    <Button
                                        types="text"
                                        style={{
                                            color: '#999',
                                            fontWeight: 500,
                                            marginRight: '10px',
                                        }}
                                    >
                                        一键完成
                                    </Button>
                                </PopverConfirm2>
                            )}
                        {orderDetailReq.data?.order.status === 2 &&
                        priceGap &&
                        !Object.keys(orderDetailReq.data?.supplement_refund_info || {}).length ? (
                            <Button
                                types="default"
                                onClick={() => {
                                    showLayer(
                                        <MallOrderReplenish
                                            payments={orderDetailReq.data!.payments}
                                            orderId={orderDetailReq.data!.order.order_id}
                                            orderType={orderDetailReq.data!.order.order_type}
                                            timeDiscountAmount={timeDiscount || 0}
                                            discountAmount={memberDiscount || 0}
                                            goodList={goodList}
                                            price={orderDetailReq.data!.order.actual_payment}
                                            gapPrice={priceGap}
                                            refresh={() => {
                                                orderDetailReq.refresh()
                                                mallOrderStore.setOrderListRefresh()
                                            }}
                                        />,
                                    )
                                }}
                            >
                                确认订单
                            </Button>
                        ) : (
                            <>
                                {orderDetailReq.data?.order.refund_status === 0 &&
                                    [2, 3, 4, 5].includes(orderDetailReq.data?.order.status) && (
                                        <Button
                                            style={{
                                                marginRight: '10px',
                                            }}
                                            types="error"
                                            disabled={!orderDetailReq.data}
                                            onClick={() => {
                                                layerManage.pop()
                                                showLayer(
                                                    <MallOrderRefund
                                                        done={!!orderDetailReq.data?.supplement_refund_info.is_done}
                                                        deliverFee={orderDetailReq.data?.order.actual_delivery_fee}
                                                        orderId={orderDetailReq.data!.order.order_id}
                                                        orderType={orderDetailReq.data!.order.order_type}
                                                        goodList={orderDetailReq.data?.order_goods_list || []}
                                                        payments={orderDetailReq.data?.payments || []}
                                                    />,
                                                )
                                            }}
                                        >
                                            退款
                                        </Button>
                                    )}
                                {typeof orderStatusAction === 'object' &&
                                    orderStatusAction?.text &&
                                    orderDetailReq.data?.order.status !== 4 && (
                                        <Button
                                            types="default"
                                            disabled={orderStatusAction.disabled ?? false}
                                            onClick={orderStatusAction.action}
                                        >
                                            {orderStatusAction.subText ? (
                                                <div data-column-center-center>
                                                    <p data-font-size-14>{orderStatusAction.text}</p>
                                                    <p data-font-size-12>{orderStatusAction.subText}</p>
                                                </div>
                                            ) : (
                                                <span>{orderStatusAction.text}</span>
                                            )}
                                        </Button>
                                    )}
                                {typeof orderStatusAction === 'function' &&
                                    orderDetailReq.data?.order.status === 4 &&
                                    orderDetailReq.data?.order.refund_status === 1 && (
                                        <Row data-align-items-center>
                                            <div
                                                className={cls('refund-accpet')}
                                                onClick={() => orderStatusAction('accpet')?.action()}
                                            >
                                                确认退款
                                            </div>
                                            <div
                                                className={cls('refund-refuse')}
                                                onClick={() => orderStatusAction('refuse')?.action()}
                                            >
                                                拒绝退款
                                            </div>
                                        </Row>
                                    )}
                            </>
                        )}
                    </Row>
                </div>
            </Column>
        </BaseDrawer>
    )
}

export default MallOrderDetail
